// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pay-option .el-radio{margin-right:20px;vertical-align:middle}.pay-option .el-radio .el-radio__label{display:inline-block}.pay-option .el-radio .el-radio__input{height:38px}.mobile_dialog{overflow:hidden!important;height:100%;display:flex;align-items:flex-end}.mobile_dialog .el-dialog{height:315px;margin-bottom:0;max-width:100vh}.mobile_dialog .el-dialog__header{height:20px;background-color:#fff}.mobile_dialog.order .el-dialog{height:355px}", ""]);
// Exports
module.exports = exports;
